import { useTranslation } from 'react-i18next';
import { useVisitorCount } from '../../hooks/useVisitorCount';

export function Footer() {
  const { t } = useTranslation();
  const visitorCount = useVisitorCount();

  return (
    <footer className="border-t border-border py-8">
      <div className="mx-auto max-w-6xl px-6 text-center">
        <p className="font-mono text-xs text-text-muted">
          {t('footer.builtWith')} AWS CDK + React + Bedrock — {t('footer.by')}
        </p>
        {visitorCount !== null && (
          <p className="mt-2 font-mono text-xs text-text-muted">
            <span className="text-accent">{visitorCount.toLocaleString()}</span> {t('footer.visitors')}
          </p>
        )}
      </div>
    </footer>
  );
}
